import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { FieldValues } from "react-hook-form";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { corporateHost } from "~/Utils";
import { SingleCabinLuggagePolicy } from "./SingleCabinLuggagePolicy";
import { GuidelinesForCheckedinLuggage } from "./GuidelinesForCheckedinLuggage";

export const BaggageGuide = () => {
  const query = useQuery();
  const navigate = useNavigate();
  
  const travellersInfoCard =[
    {
      label: "Single Cabin Luggage Policy",
      key: "singleCabinLuggagePolicy",
      children: <SingleCabinLuggagePolicy/>
    },
    {
        label: "Guidelines for Checked-in Luggage",
        key: "guidelinesForCheckedinLuggage",
        children: <GuidelinesForCheckedinLuggage/>
    }
  ]


  return (
    // <ContentWrapper>
      <Tabs
      activeKey={query?.get("thirdChildActiveTab") || ""}
      items={travellersInfoCard}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
